export const EXPERIMENT_FLAG_PREFIX = "show-reverse-trial-opd-";
export const TOUCH_POINT_CONFIG_FLAG_PREFIX = "reverse-trial-opd-config-";
export const GET_DIALOG_MESSAGE_TYPE = "reverse-trial.get-dialog";
export const STEP_PREF_KEY = "reverse_trial_step";
export const TRIAL_START_DATE_PREF_KEY = "reverse_trial_start_date";
export const DIALOG_ACTION_MESSAGE_TYPE = "reverse-trial.dialog-action";
export const DIALOG_SHOWN_MESSAGE_TYPE = "reverse-trial.dialog-shown";
export const DISMISS_DIALOG_MESSAGE_TYPE = "reverse-trial.dismiss-dialog";
export const GET_DIALOG_SHOULD_STILL_SHOW_MESSAGE_TYPE = "reverse-trial.get-dialog-should-still-show";
export const DIALOG_MARKER_ATTRIBUTE = "data-rt-opd";
export const MS_PER_DAY = 1000 * 60 * 60 * 24;
export const YT_MASTHEAD_TIMEOUT_MS = 10000;
